import { NavBar } from 'vant';
import 'vant/es/nav-bar/style';
export default {
  components: {
    NavBar
  },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  setup() {
    const onClickLeft = () => history.back();
    return {
      onClickLeft
    };
  }
};